var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlSpace: "preserve"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#162D51",
    cx: 246.8,
    cy: 250.7,
    rx: 243.2,
    ry: 243.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E09F34",
    d: "M462 365.3c19.8-33.7 27.4-72.9 27.4-114.4C489.3 116.8 380.6 8 246.5 8S3.6 116.8 3.6 250.9s108.7 242.9 242.9 242.9c13.7 0 27.1-1.2 40.2-3.3 11-45.8 51.8-153.7 175.3-125.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B1729",
    d: "m237.4 145.7 52.6-33 11.5 38.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBC5B7",
    d: "M246.9 5.6C111.7 5.6 2 114.7 2 249.3 2 280 9.2 314 23.1 346.4l27.1-35.1 24.5-9.6L32 365c2 3.8 4.1 7.6 6.3 11.3L66 340.2l24.5-9.6-41.8 61.9c3.4 4.9 7 9.8 10.8 14.5l25.1-35 24.5-9.6-38.7 57.2c23.7 25.5 53.4 46.2 88.8 57.9l18.6-72.9 47.5-37.6 113.8-62.5s90.4-3.3 139.8 22.4c5.6-20.4 12.8-54.2 12.8-77.7 0-136.5-109.6-243.6-244.8-243.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m171 284.5 1.3 7.7 5.2 1.3-3.8 2.4 2 8.6h51.6l-12.5-23z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1B380",
    d: "m168.7 303-2.5 8.7 8.3 6.5-8.8 17.5 34.7 16.6 86.1-32.1 19.5-52.4-76-6-68.8 8.3 2.2 16.8 47.4-2.8 11.3 16.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC9B6D",
    d: "m161.2 270.1 1.4 11.4 56.7-4 20.7 32.1-39.2 28.2-22-3.5-4.3-16.1-8.8 17.5 34.7 16.6 86.1-32.1 19.3-51.8-80.5-5.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#AE8866",
    d: "M283.8 228s-41.4 59.1-35.1 106.3l37.8-14.1 19.5-52.5-22.2-39.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#AE742A",
    d: "M355.9 209.4 385.5 349l-158.2 70.5-3.6-75.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#785840",
    d: "m161.5 272.5 65-7.5 66.7 8 12.8-5.2-79.8-5.2-65 7.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C1B2F",
    d: "M299.4 150v-38.7l-62 32.6z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#E09F34",
    d: "m306 267.8-80.7-5.1-83.9 10 16.3-50.5-10.7-10.6 14.1-23.1 2-17.7S207 121.7 299.4 150"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#10223E",
    d: "M299.4 150s-90.3-8.2-121.6 27l-1.6 12.9-15.1 24.7 8.4 6.7-26.3 51.2 82.9-9.9 79.8 5.2 50-58.4 14.1-90.9-70.6 31.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m199.1 225 25.5-9.7 21.1 1.6-23.3 7.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#E09F34",
    d: "m355.9 209.4 20.2 136-170 108.4 99.9-186"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8A84",
    d: "m23.1 346.4 27.1-35.1 24.5-9.6L32 365s-5.2-7.2-8.9-18.6zM70.5 419.6l38.6-57.2-24.5 9.6-25.1 34.9zM38.3 376.3l10.4 16.2 41.8-61.9-26.1 10.2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#AE742A",
    d: "m172 482.1 14.3-23.5-7.6 25.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#223C75",
    d: "M365.3 374.3s63.2-18.2 76.4 21.8l20.2-30.8s-49.8-17.4-94.6 8.4"
  })));
};
export default SvgLogo;